module.exports = __webpack_public_path__ + "img/91b02.e4739ee8.svg";